import type { XY } from "../xy";
import { XYEffect } from "./xyEffect";

export class SmokeEffect extends XYEffect {
	static key = "SmokeEffect";
	constructor(xy: XY) {
		super(xy);
	}
}
